var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: 30,
      height: 34,
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.61248 204.8c0-11.30496-9.17504-20.48-20.48-20.48L256 184.32c-11.30496 0-20.48 9.17504-20.48 20.48l0 614.4c0 11.32544 9.17504 20.48 20.48 20.48l154.13248 0c11.30496 0 20.48-9.15456 20.48-20.48L430.61248 204.8zM389.65248 798.72 276.48 798.72 276.48 225.28l113.17248 0L389.65248 798.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M706.56 184.32l-154.13248 0c-11.30496 0-20.48 9.17504-20.48 20.48l0 614.4c0 11.32544 9.17504 20.48 20.48 20.48L706.56 839.68c11.30496 0 20.48-9.15456 20.48-20.48L727.04 204.8C727.04 193.49504 717.86496 184.32 706.56 184.32zM686.08 798.72l-113.17248 0L572.90752 225.28 686.08 225.28 686.08 798.72z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.c218ab722c8a8505a6ebf142156ea125.svg";
export { ForwardRef as ReactComponent };